import { useState, useEffect } from "react"
const useSystemDarkMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    () =>
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
  )
  useEffect(() => {
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)")

    const handleChange = (e) => {
      setIsDarkMode(e.matches)
    }
    // Agregar listener
    if (darkModeQuery.addEventListener) {
      darkModeQuery.addEventListener("change", handleChange)
    } else {
      // Fallback para navegadores antiguos (ej. Safari < 14)
      darkModeQuery.addListener(handleChange)
    }
    // Cleanup
    return () => {
      if (darkModeQuery.removeEventListener) {
        darkModeQuery.removeEventListener("change", handleChange)
      } else {
        darkModeQuery.removeListener(handleChange)
      }
    }
  }, [])
  return isDarkMode
}
export default useSystemDarkMode
